import React from 'react';
import { Text, UnstyledButton } from '@mantine/core';
import { IconBrandSpeedtest } from '@tabler/icons-react';
import type { ScheduleRecalcEnginePreference } from '../../../gantt/scheduleRecalcEnginePreference';

export interface GanttRecalcEngineTogglesProps {
  value: ScheduleRecalcEnginePreference;
  onChange: (engine: ScheduleRecalcEnginePreference) => void;
}

const TILES: {
  id: Exclude<ScheduleRecalcEnginePreference, null>;
  label: string;
  Icon: typeof IconBrandSpeedtest;
}[] = [
  { id: 'MPXJ', label: 'MPXJ', Icon: IconBrandSpeedtest },
];

/**
 * Schedule-engine picker as compact inline chips (Tools → Engine).
 * Click active again to clear → Recalculate falls back to DHTMLX.
 */
export function GanttRecalcEngineToggles({ value, onChange }: GanttRecalcEngineTogglesProps) {
  return (
    <>
      {TILES.map(({ id, label, Icon }) => {
        const active = value === id;
        return (
          <UnstyledButton
            key={id}
            type="button"
            className="gantt-tools-action-chip"
            aria-pressed={active}
            data-active={active ? 'true' : undefined}
            onClick={() => onChange(active ? null : id)}
            title="Click again to clear. None selected: Recalculate uses DHTMLX. Live Schedule always uses DHTMLX."
          >
            <Icon
              size={13}
              stroke={1.6}
              color={
                active ? 'var(--mantine-color-text)' : 'var(--mantine-color-dimmed)'
              }
            />
            <Text
              component="span"
              style={{
                fontSize: 11,
                fontWeight: 600,
                lineHeight: 1.2,
                color: active ? undefined : 'var(--mantine-color-dimmed)',
              }}
            >
              {label}
            </Text>
          </UnstyledButton>
        );
      })}
      <Text
        component="span"
        c="dimmed"
        style={{ fontSize: 11, lineHeight: 1.2, whiteSpace: 'nowrap' }}
      >
        {value ? `${value} selected` : 'None — Recalculate uses DHTMLX'}
      </Text>
    </>
  );
}
